import { render, staticRenderFns } from "./ChangeAvatar.vue?vue&type=template&id=115e04e0&scoped=true"
import script from "./ChangeAvatar.vue?vue&type=script&lang=js"
export * from "./ChangeAvatar.vue?vue&type=script&lang=js"
import style0 from "./ChangeAvatar.vue?vue&type=style&index=0&id=115e04e0&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e04e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115e04e0')) {
      api.createRecord('115e04e0', component.options)
    } else {
      api.reload('115e04e0', component.options)
    }
    module.hot.accept("./ChangeAvatar.vue?vue&type=template&id=115e04e0&scoped=true", function () {
      api.rerender('115e04e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemModule/accountSetting/components/ChangeAvatar.vue"
export default component.exports